import {
    GET_LIST_CUSTOMER_SOURCE,
    GET_SPECIFIC_CUSTOMER_SOURCE,
    UPDATE_SPECIFIC_CUSTOMER_SOURCE,
    CREATE_NEW_CUSTOMER_SOURCE,
    REMOVE_CUSTOMER_SOURCE,
    GET_CUSTOMER_SOURCE_ACTIVE
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    customer_source_list: [],
    current_customer_source: null,
    customer_source_active_list: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 50
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_CUSTOMER_SOURCE: {
            return {
                ...state,
                customer_source_list: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        case GET_CUSTOMER_SOURCE_ACTIVE: {
            return {
                ...state,
                customer_source_active_list: action.payload.data,
            }
        }
        case GET_SPECIFIC_CUSTOMER_SOURCE: {
            return { ...state, current_customer_source: action.payload }
        }
        case CREATE_NEW_CUSTOMER_SOURCE: {
            return {
                ...state,
                customer_source_list: [action.payload, ...state.customer_source_list],
                customer_source_active_list: [action.payload, ...state.customer_source_active_list],
                total: state.total + 1
            }
        }
        case UPDATE_SPECIFIC_CUSTOMER_SOURCE: {
            let index = state.customer_source_list.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp = [...state.customer_source_list];
            temp[index] = action.payload;
            //
            let index2 = state.customer_source_active_list.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp2 = [...state.customer_source_active_list];
            temp[index2] = action.payload;

            return { ...state, customer_source_list: temp, customer_source_active_list: temp2 }
        }
        case REMOVE_CUSTOMER_SOURCE: {
            let temp = state.customer_source_list.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });

            let temp2 = state.customer_source_active_list.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });
            return { ...state, customer_source_list: temp, customer_source_active_list: temp2 }
        }
        default: return { ...state };
    }
}
